import React, { useState } from 'react'
import { ArrowLeft } from 'react-feather'

import { SlideUpPopover } from '@frame/ui-components/slide-up-popover'
import { Button } from '@frame/ui-primitives/button'
import { H3 } from '@frame/ui-primitives/h3'

import { DataAttribute } from '@frame/types'

type Props = {
  isOpen: boolean
  onClose: () => void
  onRemove: () => void
  onCancel: () => void
  title?: string
}

export function ConfirmRemoveDocumentPopover({ isOpen, onClose, onRemove, onCancel, title }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  function clickHandler(handler: () => void) {
    setIsLoading(true)
    handler()
    setIsLoading(false)
  }

  return (
    <SlideUpPopover show={isOpen} hide={onClose}>
      <div className="mb-4 flex items-center space-x-2">
        <Button aria-label="Back" onClick={onClose} Icon={ArrowLeft} border={false} intent="secondary" />
        <H3>{title ? title : 'Remove document?'}</H3>
      </div>
      <div className="flex flex-col gap-5" data-cy={DataAttribute.DOCUMENTS_REMOVE_DOCUMENT_POPOVER}>
        <div className="flex flex-col gap-3">
          <Button
            data-cy={DataAttribute.DOCUMENTS_REMOVE_DOCUMENT_CANCEL_BUTTON}
            intent="secondary"
            onClick={() => clickHandler(onCancel)}
            disabled={isLoading}
          >
            Go back
          </Button>
          <Button
            data-cy={DataAttribute.DOCUMENTS_REMOVE_DOCUMENT_CONFIRM_BUTTON}
            onClick={() => clickHandler(onRemove)}
            disabled={isLoading}
            intent="error"
          >
            Remove file
          </Button>
        </div>
      </div>
    </SlideUpPopover>
  )
}
